export default __webpack_public_path__ + "static/media/rounded-bottom-2.561b8b79.webp";